// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import HelloController from "./hello_controller"
application.register("hello", HelloController)


import PriceVariantsController from "./price_variants_controller"
application.register("price-variants", PriceVariantsController)

import ProductFormController from "./product_form_controller"
application.register("product-form", ProductFormController)

import ModificationsController from "./modifications_controller"
application.register("modifications", ModificationsController)

import ProductSelector from "./product_selector_controller"
application.register("product-selector", ProductSelector)

import QuotationLinesController from "./quotation_lines_controller"
application.register("quotation-lines", QuotationLinesController)

import QuotationLinesRowController from "./quotation_lines_row_controller"
application.register("quotation-lines-row", QuotationLinesRowController)

import Quotation_controller from "./quotation_controller"
application.register("quotation", Quotation_controller)

import Notification from '@stimulus-components/notification'
application.register('notification', Notification)

import ModalController from "./modal_controller"
application.register("modal", ModalController)

import BomController from "./bom_modal_controller"
application.register("bom-modal", BomController)

import CustomerSelectController from "./customer_select_controller"
application.register("customer-select", CustomerSelectController)

import RevealController from '@stimulus-components/reveal'
application.register('reveal', RevealController)

import DiscountController from './discount_controller'
application.register('discount', DiscountController)

import ProductSelectController from "./product_select_controller"
application.register("product-select", ProductSelectController)